
































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import DaftarBaris from "@/components/kunjunganPasien/SkmDaftarBaris.vue";
import SkmSvc from "@/services/SuratKeteranganMedis";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { SKM_ATAS_NAMA_OPSI, SkmRecord } from "@/types/suratKeteranganMedis";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

@Component({
  components: {
    CardModalTtd,
    PersonAutoComplete,
    "v-c-date-time-picker": VCDateTimePicker,
    DaftarBaris
  }
})
export default class DialogSuratKeteranganMedis extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ default: null }) readonly register!: string | number;

  atasNamaOpsi = SKM_ATAS_NAMA_OPSI;

  record: SkmRecord = null;
  unitId: string = null;
  loading = false;
  menarik = false;
  menyimpan = false;
  menghapus = false;
  mencetak = false;
  modalTtd = false;
  slotTtd = 1;

  form = this.formKosong();

  get dialog() {
    return this.value;
  }

  set dialog(v: boolean) {
    this.$emit("input", v);
  }

  get pasien() {
    const p: any = storePasien.identitasPasien || {};

    return {
      nama: p.nama || "",
      rm: p.rm || "",
      jk: p.jk || p.jenis_kelamin || "",
      tglLahir: p.tgl_lahir || "",
      alamat: p.alamat || ""
    };
  }

  get sudahTtd1(): boolean {
    return !!(this.record && this.record.signed_at);
  }

  get sudahTtd2(): boolean {
    return !!(this.record && this.record.content && this.record.content.signed_2_at);
  }

  /** Dokumen terkunci begitu salah satu pihak menandatangani. */
  get terkunci(): boolean {
    return this.sudahTtd1 || this.sudahTtd2;
  }

  get bisaHapus(): boolean {
    if (!this.record) return false;
    return !alasanTtdMengunciHapus(
      this.record.creator_user_id,
      [
        { ditandatangani: this.sudahTtd1, penandaTanganId: this.record.signee_user_id },
        { ditandatangani: this.sudahTtd2, penandaTanganId: this.record.content ? this.record.content.signee_2_user_id : null }
      ],
      userModule.user?.id
    );
  }

  get bisaTtd1(): boolean {
    return !this.sudahTtd1 && !!this.form.signee_user_id;
  }

  get bisaTtd2(): boolean {
    return !this.sudahTtd2 && !!this.form.signee_2_user_id;
  }

  /**
   * Nilai tersimpan bisa "Y-m-d H:i:s" (resume/rmk) atau ISO ber-offset
   * (discharge_at). Dipecah manual — `new Date("2026-05-14")` diparse sebagai
   * UTC sehingga tanggal bisa mundur sehari di zona Jakarta.
   */
  get waktuMeninggal(): Date {
    const v = this.form.kondisi_pulang.meninggal_at;

    if (!v) {
      return null;
    }

    const bagian = String(v).replace("T", " ").split(" ");

    return composeDate(bagian[0], bagian[1] ? bagian[1].substring(0, 5) : "00:00");
  }

  formKosong() {
    return {
      nomor: "",
      tempat_lahir: "",
      narasi_registrasi: "",
      diagnosis: [] as Array<{ text: string }>,
      tindakan: [] as Array<{ text: string }>,
      obat: [] as Array<{ text: string }>,
      kondisi_pulang: {
        tampil: false,
        meninggal: false,
        meninggal_at: null as string,
        text: ""
      },
      kesimpulan: "",
      atas_nama: SKM_ATAS_NAMA_OPSI[0],
      signee_user_id: null as number,
      signee_2_user_id: null as number
    };
  }

  @Watch("value")
  onDialog(buka: boolean) {
    if (buka) {
      this.muat();
    }
  }

  async muat() {
    this.loading = true;

    try {
      const list = await SkmSvc.getByRegister(this.register);
      const rows = Array.isArray(list) ? list : list?.data;

      this.record = rows && rows.length ? rows[0] : null;

      if (this.record) {
        this.unitId = this.record.unit_id;
        this.hidrasi(this.record);
      } else {
        this.form = this.formKosong();
        await this.tarikDataRme(true);
      }
    } finally {
      this.loading = false;
    }
  }

  hidrasi(rec: SkmRecord) {
    const c: any = rec.content || {};
    const kosong = this.formKosong();

    this.form = {
      ...kosong,
      ...c,
      nomor: rec.nomor || "",
      diagnosis: Array.isArray(c.diagnosis) ? c.diagnosis : [],
      tindakan: Array.isArray(c.tindakan) ? c.tindakan : [],
      obat: Array.isArray(c.obat) ? c.obat : [],
      kondisi_pulang: { ...kosong.kondisi_pulang, ...(c.kondisi_pulang || {}) },
      signee_user_id: rec.signee_user_id,
      signee_2_user_id: c.signee_2_user_id || null
    };
  }

  /**
   * Nilai kosong dari server tidak pernah menimpa ketikan petugas; saat
   * dokumen baru (`awal`) seluruh isian memang masih kosong.
   */
  async tarikDataRme(awal = false) {
    if (this.terkunci) {
      return;
    }

    this.menarik = true;

    try {
      const d = await SkmSvc.autofill(this.register);

      if (!d) {
        return;
      }

      if (d.narasi_registrasi && (awal || !this.form.narasi_registrasi)) {
        this.form.narasi_registrasi = d.narasi_registrasi;
      }

      if (d.diagnosis?.length && (awal || !this.form.diagnosis.length)) {
        this.form.diagnosis = d.diagnosis;
      }

      if (d.tindakan?.length && (awal || !this.form.tindakan.length)) {
        this.form.tindakan = d.tindakan;
      }

      if (d.obat?.length && (awal || !this.form.obat.length)) {
        this.form.obat = d.obat;
      }

      if (d.kondisi_pulang && (awal || !this.form.kondisi_pulang.text)) {
        this.form.kondisi_pulang = { ...this.form.kondisi_pulang, ...d.kondisi_pulang };
      }

      if (d.unit_id) {
        this.unitId = d.unit_id;
      }

      if (d.signee_user_id && !this.form.signee_user_id) {
        this.form.signee_user_id = d.signee_user_id;
      }

      if (!awal) {
        appModule.NoticeDelay("Data RME ditarik ulang");
      }
    } finally {
      this.menarik = false;
    }
  }

  /** VCDateTimePicker meng-emit Date; simpan sebagai string lokal. */
  setWaktuMeninggal(val: Date) {
    this.form.kondisi_pulang.meninggal_at = val
      ? `${toDateString(val)} ${toTimeString(val)}`
      : null;
  }

  payload() {
    const bersih = (rows) =>
      (rows || []).filter(r => r && String(r.text || "").trim() !== "");

    return {
      register_id: this.register,
      pasien_rm: this.pasien.rm,
      unit_id: this.unitId,
      nomor: this.form.nomor || null,
      surat_date: this.record?.surat_date || null,
      signee_user_id: this.form.signee_user_id,
      creator_user_id: this.record?.creator_user_id || undefined,
      content: {
        tempat_lahir: this.form.tempat_lahir,
        narasi_registrasi: this.form.narasi_registrasi,
        diagnosis: bersih(this.form.diagnosis),
        tindakan: bersih(this.form.tindakan),
        obat: bersih(this.form.obat),
        kondisi_pulang: this.form.kondisi_pulang,
        kesimpulan: this.form.kesimpulan,
        atas_nama: this.form.atas_nama,
        signee_2_user_id: this.form.signee_2_user_id,
        signed_2_at: this.record?.content?.signed_2_at || null
      }
    };
  }

  async simpan() {
    this.menyimpan = true;

    try {
      const resp = this.record
        ? await SkmSvc.update(this.record.id, this.payload())
        : await SkmSvc.create(this.payload());

      if (resp?.data?.status == 1) {
        appModule.NoticeDelay("Surat Keterangan Medis berhasil disimpan");
        await this.muat();
        this.$emit("saved");
      }
    } finally {
      this.menyimpan = false;
    }
  }

  bukaTtd(slot: number) {
    this.slotTtd = slot;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    try {
      if (this.slotTtd === 2) {
        await SkmSvc.signSecond(this.record.id, { password });
      } else {
        await SkmSvc.sign(this.record.id, { password });
      }

      this.modalTtd = false;
      appModule.addMsgTtd("");
      appModule.NoticeDelay("Berhasil menandatangani");
      await this.muat();
      this.$emit("saved");
    } catch (e) {
      this.modalTtd = true;
    }
  }

  async cetak() {
    this.mencetak = true;

    try {
      await SkmSvc.print(this.record.id);
    } finally {
      this.mencetak = false;
    }
  }

  async hapus() {
    if (!this.bisaHapus) {
      return;
    }
    if (!confirm("Anda yakin akan menghapus Surat Keterangan Medis ini?")) {
      return;
    }

    this.menghapus = true;

    try {
      await SkmSvc.destroy(this.record.id);
      appModule.NoticeDelay("Surat Keterangan Medis dihapus");
      this.record = null;
      this.form = this.formKosong();
      this.$emit("saved");
      this.dialog = false;
    } finally {
      this.menghapus = false;
    }
  }

  tutup() {
    this.dialog = false;
  }
}
